// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/trait/telemetry/v1/heart_rate.proto (package msh.trait.telemetry.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { CaptureMode } from "../../../common/v1/capture_mode_pb";

/**
 * @generated from message msh.trait.telemetry.v1.HeartRateTrait
 */
export const HeartRateTrait = proto3.makeMessageType(
  "msh.trait.telemetry.v1.HeartRateTrait",
  [],
);

/**
 * @generated from message msh.trait.telemetry.v1.HeartRateTrait.HeartRateEvent
 */
export const HeartRateTrait_HeartRateEvent = proto3.makeMessageType(
  "msh.trait.telemetry.v1.HeartRateTrait.HeartRateEvent",
  () => [
    { no: 1, name: "start_time", kind: "message", T: Timestamp },
    { no: 2, name: "end_time", kind: "message", T: Timestamp },
    { no: 3, name: "mean", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "std_deviation", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "min", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "q1", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "q2", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "q3", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "max", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "num_sample", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 11, name: "capture_mode", kind: "enum", T: proto3.getEnumType(CaptureMode) },
    { no: 12, name: "timestamp", kind: "message", T: Timestamp },
  ],
  {localName: "HeartRateTrait_HeartRateEvent"},
);

